import {
  React,
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import { useLocation } from "react-router-dom";
import { Messages } from "primereact/messages";
import { confirmDialog } from "primereact/confirmdialog";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Accordion, AccordionTab } from "primereact/accordion";
import { cartMenu, notificationMenu, term_and_condition } from "../constant";
import Popover from "react-bootstrap/Popover";
import { Badge } from "primereact/badge";
import {
  downloadItem,
  toSnakeCase,
  formatDate,
  getElapsedTime,
  getMenuItems,
  downloadFilesAsZip,
  getNotificationRoute,
} from "../utilities";
import ProgressButton from "react-progress-button";
import $ from "jquery";
import { T } from "../helpful";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import {
  clearCart,
  toggleMenuDisplay,
  setActiveItem,
  setLatestDocument,
  setDynamicRoutes,
  setActiveAccordion,
  setActiveSubMenu,
  resetMenu,
  resetApp,
  resetUser,
  setActiveMenu,
  signOut,
} from "../../store/reducer";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import * as formik from "formik";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import {
  getNewDocuments,
  saveDocumentsViewByUser,
  sendCart,
  logout,
} from "../../api/api";
import { LangContext } from "../../context/context";
import { useQueryClient } from "@tanstack/react-query";
import { NewDocumentsSkeleton } from "../skeleton";

/**
 * The `SubMenu` component renders a menu based on the props passed to it.
 * If the menu type is "post", it renders a list of latest documents.
 * If the menu type is "accordion-menu", it renders an accordion menu with dynamic tabs based on the active items.
 * If the menu type is "simple-menu", it renders a menu list with dynamic items.
 * @param {Object} props - The props object passed to the component
 * @param {string} props.menu.type - The type of the menu to render
 * @param {string} props.menu.id - The id of the menu to render
 * @param {string} props.menu.name - The name of the menu to render
 * @param {string} props.menu.url - The url of the menu to render
 * @param {Object} props.menuItems - The items of the menu to render
 * @param {Object} props.activeAccordion - The active accordion item
 * @param {Object} props.latestDocs - The latest documents to render in the "post" menu type
 * @author lionel ghogue ngondeke <lionelladrog@gmail.com> 2024/05/12
 */

export default function SubMenu(props) {
  const menu = useSelector((state) => state.menu);
  const toast = useRef(null);
  const msgs = useRef(null);
  const location = useLocation();
  const queryClient = useQueryClient();
  const activeSubMenu = menu.activeSubMenu;
  const menu_activeAccordion = menu.activeAccordion;
  const user = useSelector((state) => state.user);
  const latestDocs = useSelector((state) => state.appState.latestDocuments);
  const cart = useSelector((state) => state.cart);
  const routes = useSelector((state) => state.menu.dynamicRoutes);
  const cartCounter = cart.counter;
  const cartTotal = cart.totalSize;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [hasAccepted, setHasAccepted] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [visible, setVisible] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [isCartFull, setIsCartFull] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [activeAccordion, setActAccordion] = useState(0);

  useEffect(() => {
    const getItems = async () => {
      let items = await getMenuItems(t.language);
      setMenuItems(items);
    };
    getItems();
  }, [t.language]);

  useEffect(() => {
    setActAccordion(menu_activeAccordion ?menu_activeAccordion:0)
    
  },[activeAccordion,location])


  const accept = async () => {
    let islogout = await logout();

    if (islogout) {
      queryClient.clear();
      dispatch(resetUser({}));
      dispatch(resetApp({}));
      dispatch(resetMenu({}));
      dispatch(clearCart({}));
      dispatch(signOut({}));
      navigate("/");
    }
  };

  const reject = () => {
    return;
  };

  const handleMenuDisplay = async (e, item, id = "") => {
    e.preventDefault();
    let elt = e.currentTarget.id;

    if (elt === "logout") {
      LogOut(e);
      return;
    }

    dispatch(setActiveItem(item));
    dispatch(setActiveSubMenu(item.id));

    let url = item.url;
    const hotel_ids = [1, 2, 3, 4, 5, 6, 7, 8];

    if (
      item.parent_id === "hotel" ||
      item.url === "/room-status" ||
      hotel_ids.includes(Number(id))
    ) {
      url = item.url + "/" + id;
    }

    $(".sub-menu-nav-item a").removeClass("bcb-bg-primary-light");
    $("#" + e.currentTarget.id).addClass("bcb-bg-primary-light");
    navigate(url);
  };

  const LogOut = (e) => {
    e.preventDefault();
    let confirm = t("are_you_sure_to_log_out");
    let logout = t("log_out");

    confirmDialog({
      message: confirm,
      header: logout,
      icon: "pi pi-info-circle",
      defaultFocus: "accept",
      accept,
      reject,
    });
  };

  const NewDocuments = () => {
    /**
     * The `NewDocuments` function in JavaScript displays a list of latest documents with options to view
     * details and download them.
     * @returns The `NewDocuments` component is returning JSX elements that include a heading, a "See
     * all" link, and a list of new upload items. Each new upload item is displayed with its title,
     * creation date, and a download button. The component also includes a popover for each item that
     * shows an image when clicked. If there are no latest documents available, a `NewDocumentsSkeleton`
     * component is
     */

    const { lang } = useContext(LangContext);

    const [activeIndex, setActiveIndex] = useState(null);
    const targetRefs = useRef([]);
    const newDocuments = useSelector((state) => state.appState.latestDocuments);
    const [latestDocuments, setLatestDocuments] = useState([]);
    
    const dispatch = useDispatch();
    let title = "New Uploads";

   

    useEffect(() => {
      if (newDocuments) {
        setLatestDocuments(newDocuments);
      }

    }, [newDocuments, latestDocuments]);

   

    const handleToggle = async (item, show, index) => {
      let newDoc;
      if (show) {
        setActiveIndex(index);

        const doc = {
          id: item.id,
          has_view_id: item.has_view_id,
          uuid: item.uuid,
          has_view: item.has_view,
          user_id: user.userID,
        };

        let isSaved = await saveDocumentsViewByUser(doc);

        if (isSaved) {
          newDoc = await getNewDocuments(user.userID);

          if (newDoc.data.length > 0) {
            setLatestDocuments(newDoc.data);
          }
        }
      } else {
        newDoc = await getNewDocuments(user.userID);
        dispatch(setLatestDocument(newDoc));
        setActiveIndex(null);
      }
    };

    const handleSeeAllLink = (e) => {
      e.preventDefault();
      let items = [notificationMenu];
      let notification = items[0];
      let url = "/notifications";

      let children = getNotificationRoute(latestDocs);

      dispatch(toggleMenuDisplay([]));
      if (children.length > 0) {
        notification.firstChildID = children[0].id;
        url = children[0].url;
        dispatch(toggleMenuDisplay(notification));
      }

      navigate(url);
    };

    const showPopover = (item) => {
      return (
        <Popover id="popover-basic">
          <Popover.Header as="div">
            <div className="latest-docs-wrapper">
              <img src={item.src} className="img-fluid" alt={item.title} />
            </div>
          </Popover.Header>
        </Popover>
      );
    };

    if(isloading) {
      return <>loading</>
    }

   

    return (
      <>
        <div className="d-flex justify-content-between mb-2">
          <h6 className="">{t(toSnakeCase(title))}:</h6>
          <a
            href="/"
            className="text-small bcb-text-primary"
            onClick={(e) => handleSeeAllLink(e)}
          >
            See all
          </a>
        </div>
        <div className="new-upload-wrapper">
          <ul className="nav flex-column sub-simple-menu-items">
            {latestDocuments.length > 0 ? (
              latestDocuments.map((item, index) => {
                let createdAt = getElapsedTime(item.update);

                let has_view_class = "";

                has_view_class =
                  item.has_view.toString() === "0" &&
                  item.is_new.toString() === "1"
                    ? "new-new-upload "
                    : "old-new-upload ";

                return (
                  <div key={index}>
                    <OverlayTrigger
                      trigger="click"
                      placement="right"
                      delay={{ show: 250, hide: 400 }}
                      show={activeIndex === index}
                      onToggle={(show) => handleToggle(item, show, index)}
                      overlay={showPopover(item)}
                    >
                      <li
                        key={"sub-menu-nav-" + index + item.id}
                        ref={(el) => (targetRefs.current[index] = el)}
                        className="nav-item sub-menu-nav-item d-flex justify-content-between latest-docs"
                      >
                        <span
                          className={has_view_class + " new-upload"}
                          key={"new-upload-" + index + item.id}
                        >
                          <h6 className="">{item.title}</h6>
                          <span className="">
                            {createdAt > 24
                              ? formatDate(item.date)
                              : createdAt > 0
                              ? createdAt + " hours ago"
                              : "-1 hours ago "}
                          </span>
                        </span>
                        <a
                          href="/"
                          onClick={(e) => {
                            e.preventDefault();
                            downloadItem(e, item);
                          }}
                        >
                          <i className="pi pi-download mt-4"></i>
                        </a>
                      </li>
                    </OverlayTrigger>
                  </div>
                );
              })
            ) : ( <div>
              <h6>No documents available at the moment.</h6>
              <NewDocumentsSkeleton />
            </div>
              
            )}
          </ul>
        </div>
      </>
    );
  };

  const submenuLinkTemplate = (item, tabParent = "") => {
    /**
     * The function `submenuLinkTemplate` generates a submenu list of links based on the provided data
     * items.
     * @param item - The `item` parameter in the `submenuLinkTemplate` function is an array containing
     * objects that represent submenu items. Each object should have properties like `id`, `url`, and
     * `name` that are used to generate the submenu links in the template.
     * @param [tabParent] - The `tabParent` parameter in the `submenuLinkTemplate` function is used to
     * specify the parent tab of the submenu items. It is a string parameter that can be passed to the
     * function to indicate the parent tab to which the submenu items belong. This can be helpful for
     * organizing and managing the submenu
     * @returns A function named `submenuLinkTemplate` is being returned. This function takes two
     * parameters, `item` and `tabParent`, with a default value of an empty string. Inside the function,
     * it checks if the `item` parameter is undefined and returns null if it is. Otherwise, it returns a
     * JSX template that maps over the `item` array and generates a list of submenu links based on
     */

    if (item === undefined) return null;

    return (
      <div>
        <ul className="nav flex-column sub-menu-items">
          {item.map((elt, index) => {
            return (
              <li
                className={
                  "nav-item sub-menu-nav-item" +
                  (activeSubMenu === elt.id ? " isSubMenuActive " : " ")
                }
                key={"sub-menu-nav-item" + elt.id}
              >
                <a
                  className={" nav-link "}
                  aria-current="page"
                  href={elt.url}
                  key={"nav-item -" + elt.id}
                  onClick={(e) => handleMenuDisplay(e, elt, tabParent)}
                  id={elt.id}
                >
                  <i className="bi bi-caret-right-fill"></i>
                  {elt.name}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  const accordionMenuTemplate = (parentID, menuItems) => {
    /**
     * The function `accordionMenuTemplate` generates an accordion menu based on the provided parent ID
     * and menu items data.
     * @param parentID - The `parentID` parameter in the `accordionMenuTemplate` function is used to
     * filter the `menuItems` array to find items that have a matching `id` with the provided `parentID`.
     * The function then generates an accordion menu based on the found items and their children.
     * @returns The `accordionMenuTemplate` function returns a JSX template for an accordion menu based
     * on the provided `parentID`. It filters the `menuItems` array to find items with the matching
     * `parentID`, extracts the title and active items, and then generates an accordion menu structure
     * with dynamic tabs based on the active items.
     */

    const items = menuItems.filter((item) => item.id === parentID);

    if (!items || items.length === 0) return null;

    let title = items[0].name;
    let activeItems = items[0].children;

    const setActiveTab = (e) => {
      let index = e.index;
      dispatch(setActiveAccordion(index));
      setActAccordion(index);
      activeItems = items[0].children;
      let firstChild = activeItems[index]["children"][0];
      let url =
        parentID === "hotels"
          ? `${firstChild.url}/${index + 1}`
          : `${firstChild.url}`;

      dispatch(setActiveItem(firstChild)); // set active page
      dispatch(setActiveSubMenu(firstChild.id)); // to make sure the first children always be selected
      navigate(url); // redirect to the first child route
    };


    return (
      <div>
        <div className="submenu-header">
          <h5>
            <i className="pi pi-chevron-down"></i>
            {t(toSnakeCase(title))}
          </h5>
        </div>
        <div className="">
          <Accordion
            expandIcon={"pi pi-plus"}
            collapseIcon={"pi pi-minus"}
            multiple={false}
            activeIndex={activeAccordion}
            onTabOpen={setActiveTab}
          >
            {activeItems.map((tab, i) => {
              return (
                <AccordionTab
                  key={tab.name}
                  header={tab.name}
                  disabled={tab.disabled}
                >
                  {submenuLinkTemplate(tab.children, tab.id)}
                </AccordionTab>
              );
            })}
          </Accordion>
        </div>
      </div>
    );
  };

  const SimpleMenuTemplate = ({ parentID, menuItems, latestDocs }) => {
    /**
     * The `SimpleMenuTemplate` function is a simple menu component that displays a list of children of a given parentID.
     * It filters the `menuItems` array to find items with the matching `parentID`, extracts the title and active items, and
     * then generates a simple menu structure with dynamic items based on the active items.
     * For the "notification" parentID, it fetches the latest documents and generates a dynamic route for each document.
     * For the "cart" parentID, it displays a list of items in the cart and their size, and a button to download all items.
     * @param {string} parentID The ID of the parent menu item.
     * @param {object} menuItems An array of menu items.
     * @param {array} latestDocs An array of latest documents.
     * @returns The `SimpleMenuTemplate` function returns a JSX template for a simple menu based on the provided `parentID`.
     */
    const [items, setItems] = useState(
      menuItems.filter((item) => item.id === parentID)
    );
    const routes = useSelector((state) => state.menu.dynamicRoutes);
    const menu = useSelector((state) => state.menu);
    const activeSubMenu = menu.activeSubMenu;

    const dispatch = useDispatch();

    useEffect(() => {
      if (parentID === "notification") {
        let children = getNotificationRoute(latestDocs);

        if (JSON.stringify(children) !== JSON.stringify(routes)) {
          dispatch(setDynamicRoutes(children));
        }

        if (children) {
          notificationMenu.children = children;
          notificationMenu.firstChildID = children[0].id;
        } else {
          notificationMenu.children = null;
          notificationMenu.firstChildID = null;
        }

        setItems([notificationMenu]);
      }
      if (parentID === "cart") {
        setItems([cartMenu]);
      }
    }, [parentID, latestDocs, dispatch, routes]);

    let activeItems = [];
    let title = null;

    if (!items || items.length === 0) {
      return;
    }
    activeItems = items[0].children;
    title = items[0].name;

    return (
      <>
        <div className="submenu-header">
          <h5>
            <i className="pi pi-chevron-down"></i>
            {t(toSnakeCase(title))}
          </h5>
        </div>
        <div>
          <ul className="nav flex-column sub-simple-menu-items">
            {activeItems.map((elt, index) => {
              let id = parentID === "room_status" ? elt.id : "";

              return (
                <li
                  className={
                    "" + (activeSubMenu === elt.id ? " isSubMenuActive " : " ")
                  }
                  key={"sub-menu-nav-" + elt.id + Math.random()}
                >
                  {parentID === "cart" ? (
                    <span className="nav-link cart-nav-link">
                      {elt.name} :
                      {elt.counter ? (
                        <span className={"float-end "}>
                          {elt.id === "cart-size" ? (
                            <span className={isCartFull ? " text-red " : ""}>
                              {cartTotal + ` ${t("MB")}`}
                            </span>
                          ) : (
                            cartCounter
                          )}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                      {index === activeItems.length - 1 ? (
                        <p className="max-cart-size">(Max. cart size *25MB)</p>
                      ) : null}
                    </span>
                  ) : (
                    <a
                      className="nav-link "
                      aria-current="page"
                      href={elt.url}
                      key={parentID + "-" + elt.id + Math.random()}
                      onClick={(e) => handleMenuDisplay(e, elt, id)}
                      id={elt.id}
                    >
                      {elt.name}
                      {elt.unread ? (
                        <span className="float-end">
                          {" "}
                          <Badge value={elt.unread}></Badge>
                        </span>
                      ) : (
                        ""
                      )}
                    </a>
                  )}
                </li>
              );
            })}
            {parentID === "cart" ? getCartAction(msgs) : null}
          </ul>
        </div>
      </>
    );
  };

  const getCartAction = (msgs) => {
    /**
     * The `getcartAction` function returns a JSX element with a checkbox for accepting terms and
     * conditions, and buttons for clearing the cart and downloading all items.
     * @returns The `getcartAction` function returns a JSX element that includes a checkbox for accepting
     * terms and conditions, along with two buttons. One button allows the user to clear the cart by
     * dispatching a `clearCart` action when clicked, and the other button allows the user to download
     * all items in the cart.
     */
    const DeleteCart = (e) => {
      e.preventDefault();
      dispatch(clearCart());
    };

    const downloadAll = (e) => {
      e.preventDefault();
      let filenames = [];
      let urls = [];

      if (!hasAccepted) {
        setIsValid(false);
        return false;
      }
      if (cart.cart.length === 0) {
        return;
      }
      if (cart.totalSize > 25) {
        setIsCartFull(true);
        return;
      }
      urls = cart.cart.map((item) => item.filePath);
      filenames = cart.cart.map((item) => item.name);

      downloadFilesAsZip(filenames, urls);
    };

    const acceptTerm = () => {
      $("#terms-conditions").attr("checked", true);
      setHasAccepted(!hasAccepted);
      setIsValid(true);
      setVisible(false);
    };

    const showTermsAndCondition = (e) => {
      e.preventDefault();
      setVisible(true);
    };

    const showMessage = (desc, severity) => {
      msgs.current.show([
        {
          sticky: true,
          life: 3000,
          severity: severity,
          summary: "",
          detail: desc,
          closable: true,
          icon: "pi pi-send",
        },
      ]);
      setTimeout(() => {
        msgs.current.clear();
      }, 3000);
    };

    const handleOnSubmit = async (values) => {
      values.subject = "My Cart";
      if(values['cart_files'].length===0) {
        showMessage("No item found in your cart to share.", "error");
        return;
      }
      let resp = await sendCart(values);

      if (resp) {
        showMessage("Mail has been sent successfully.", "success");
      } else {
        showMessage("Mail sending failed.", "error");
      }
      return;
    };

    const { Formik } = formik;

    const schema = yup.object().shape({
      user_firstname: yup
        .string()
        .required(<T value={"Your Firstname is required"} />),
      user_lastname: yup
        .string()
        .required(<T value={"Your Lastname is required"} />),
      firstname: yup
        .string()
        .required(<T value={"Recipient Firstname is required"} />),
      lastname: yup
        .string()
        .required(<T value={"Recipient Lastname is required"} />),
      email: yup
        .string()
        .email(<T value={"Invalid email address"} />)
        .required(<T value={"Email is required"} />),
      message: yup.string().required(<T value={"Message is required"} />),
      cart: yup.array().min(1, "Cart cannot be empty"),
    });

    const popover = (
      <Popover id="share-cart-wrapper" className="  mt-2 ">
        <Popover.Body className="">
          <Formik
            validationSchema={schema}
            onSubmit={handleOnSubmit}
            initialValues={{
              firstname: "",
              lastname: "",
              email: "",
              message: "",
              cart_files: cart.cart,
              user_firstname: user.user.userOthername,
              user_lastname: user.user.userSurname,
              id: user.user.userID,
            }}
          >
            {({
              handleSubmit,
              handleChange,

              values,
              touched,
              errors,
              handleBlur,
              isSubmitting,
            }) => (
              <Form className="" noValidate onSubmit={handleSubmit}>
                <Row>
                  <Form.Group as={Col} md="12">
                    <FloatingLabel label="First Name" className="">
                      <Form.Control
                        type="text"
                        id="firstname"
                        className="custom-input"
                        placeholder="First Name"
                        name="firstname"
                        value={values.firstname}
                        onChange={handleChange}
                        isInvalid={!!errors.firstname}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.firstname}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                  </Form.Group>

                  <Form.Group as={Col} md="12">
                    <FloatingLabel label="Last Name" className="">
                      <Form.Control
                        type="text"
                        id="lastname"
                        className="custom-input"
                        placeholder="Last Name"
                        name="lastname"
                        value={values.lastname}
                        onChange={handleChange}
                        isInvalid={!!errors.lastname}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.lastname}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                  </Form.Group>

                  <Form.Group as={Col} md="12">
                    <FloatingLabel label="Email Address" className="">
                      <Form.Control
                        type="email"
                        id="email"
                        className="custom-input"
                        placeholder="Email Address"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        isInvalid={!!errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel label="Message" className="">
                      <Form.Control
                        as="textarea"
                        rows={3}
                        id="message"
                        name="message"
                        value={values.message}
                        onChange={handleChange}
                        isInvalid={!!errors.message}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.message}
                      </Form.Control.Feedback>
                    </FloatingLabel>
                  </Form.Group>

                  <button
                    type="submit"
                    className="   btn  bcb-btn-primary bcb-btn-small text-uppercase "
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-grow spinner-grow-sm"
                          aria-hidden="true"
                        ></span>
                        <span className="text-capitalize saving-block">
                          {" "}
                          Sending mail...
                        </span>
                      </>
                    ) : (
                      t("Share Cart")
                    )}
                  </button>
                </Row>
              </Form>
            )}
          </Formik>
        </Popover.Body>
      </Popover>
    );

    return (
      <div className="text-center">
        <input
          type="checkbox"
          id="terms-conditions"
          name="termsAndCondition"
          checked={hasAccepted ? true : false}
          onChange={() => acceptTerm()}
          className="me-3"
        />
        <label htmlFor="terms-conditions">
          {t("accept_the")}
          <span className="">
            {" "}
            <a
              href="/"
              className="custom-a"
              onClick={(e) => showTermsAndCondition(e)}
            >
              {t("terms_and_conditions")}
            </a>
          </span>
        </label>
        <p className={!isValid ? " size-small text-red " : " h "}>
          {t("you_must_terms_and_conditions")}
        </p>
        <div className=" cart-btn-group">
          <div className=" ">
            <button
              type="button"
              onClick={(e) => downloadAll(e)}
              className="col-12  btn bcb-btn bcb-btn-primary text-uppercase bcb-btn-small d-flex justify-content-between px-3 "
            >
              <span className="mt-1 text-bold">{t("download_all")}</span>

              <i className="bi bi-download"></i>
            </button>
            {isCartFull ? (
              <span className={"text-small  text-red"}>
                Your cart size exceeds 25 MB
              </span>
            ) : null}
          </div>
        </div>
        <Messages ref={msgs} />
        <div className="mt-3 d-flex  justify-content-center">
          <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={popover}
            className=""
          >
            <a
              href="/"
              onClick={(e) => e.preventDefault()}
              className="text-small share-to-friend text-decoration-underline text-center"
            >
              <i className="bi bi-send "></i>
              <span className="pb-2 px-2">Share Cart to a friend</span>
            </a>
          </OverlayTrigger>
        </div>

        <Dialog
          header={t("terms_and_conditions")}
          visible={visible}
          style={{ width: "50vw" }}
          onHide={() => setVisible(false)}
        >
          <p className="m-0 fst-italic">{term_and_condition}</p>
          <div className=" mt-4 text-center">
            <hr />
            <button
              type="button"
              onClick={() => acceptTerm()}
              className="btn bcb-btn bcb-btn-primary text-uppercase bcb-btn-small  "
            >
              {t("accept")}
            </button>
            <button
              type="button"
              onClick={() => setVisible(false)}
              className="btn bcb-btn bcb-btn-secondary  text-uppercase bcb-btn-small mx-3"
            >
              {t("decline")}
            </button>
          </div>
        </Dialog>
      </div>
    );
  };

  const getSubmenu = (menu) => {
    /**
     * The function `getSubmenu` returns different templates based on the type of menu provided as input.
     * @param menu - It seems like you were about to provide some information about the `menu` parameter
     * in the `getSubmenu` function. Could you please provide more details or specify what information
     * you would like to know or discuss regarding the `menu` parameter?
     * @returns The `getSubmenu` function returns different templates based on the type of the menu
     * object passed to it. If the menu type is "post", it returns the result of `postTemplate()`. If the
     * menu type is "accordion-menu", it returns the result of `accordionMenuTemplate(menu.id)`. If the
     * menu type is "simple-menu", it returns the result of `simpleMenuTemplate
     */

    switch (menu.type) {
      case "post": {
        return <NewDocuments />;
      }
      case "accordion-menu": {
        // return (
        //   <AccordionMenuTemplate parentID={menu.id} menuItems={menuItems} />
        // );

        return accordionMenuTemplate(menu.id, menuItems, activeAccordion);
      }
      case "simple-menu": {
        return (
          <SimpleMenuTemplate
            parentID={menu.id}
            menuItems={menuItems}
            latestDocs={latestDocs}
          />
        );
      }
      default: {
        return null;
      }
    }
  };

  return <div className="submenu-wrapper">{getSubmenu(menu)}</div>;
}
